import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useAuth } from '../context/authContext';

// Simple welcome panel shown after a club is selected (Option B, Phase 1).
// Replaces the lingering club table so the club-selection screen and the
// club-operation context are never shown at the same time.
function ClubHome() {
  const { user } = useAuth();
  const clubName = user?.clubName || 'your club';

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: 16,
        minHeight: 'calc(100vh - 160px)'
      }}
    >
      <Paper
        elevation={2}
        style={{ padding: 32, maxWidth: 560, width: '100%', textAlign: 'center', marginTop: 24 }}
      >
        <Typography variant="h5" gutterBottom>
          You are now managing {clubName}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Choose an action from the menu on the left to manage promotions,
          locations, redemption partners, users and more for this club.
        </Typography>
      </Paper>
    </Box>
  );
}

export default ClubHome;
